module.exports = __webpack_public_path__ + "img/setting2.189c635b.png";